import { render, staticRenderFns } from "./bannerImg.vue?vue&type=template&id=ae5ef54c&scoped=true"
import script from "./bannerImg.vue?vue&type=script&lang=js"
export * from "./bannerImg.vue?vue&type=script&lang=js"
import style0 from "./bannerImg.vue?vue&type=style&index=0&id=ae5ef54c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5ef54c",
  null
  
)

export default component.exports